import { useQuery } from "@hooks/useQuery";
import { Icon } from "@iconify/react";
import { Button, Tabs } from "antd";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { PassengerWebAppFooter } from "./WebAppFooter/WebAppFooter";
import { WebAppFooterIcons } from "./WebAppFooter/WebAppFooterIcons";

export const FooterPassenger: React.FC = () => {
  const query = useQuery();
  const navigate = useNavigate();

  const activeTab = query.get("activeTab");
  const subActiveTab = query.get("subActiveTab");
  const thirdSubActiveTab = query.get("thirdSubActiveTab");

  useEffect(() => {
    if (query.get("id")) {
      return;
    }
    if (!activeTab) {
      navigate(`${window.location.pathname}?activeTab=passengerFooter&subActiveTab=aboutAndLegal`, {
        replace: true,
      });
    }
    if (subActiveTab === "webAppFooterIcons") {
      navigate(
        `/dedicated/passenger/navigation?activeTab=passengerFooter&subActiveTab=webAppFooterIcons&thirdSubActiveTab=${query.get("thirdSubActiveTab") ?? "servicePortals"}`
      );
    }
  }, [navigate, activeTab, subActiveTab, thirdSubActiveTab]);

  // ✅ Tabs config
  const items = [
    {
      label: "About & Legal",
      key: "aboutAndLegal",
      children: <PassengerWebAppFooter />,
    },
    {
      label: "Icons",
      key: "webAppFooterIcons",
      children: <WebAppFooterIcons />,
    },
  ];

  const handleFooterAction = (subActiveTab: string) => {
    if (subActiveTab === "servicePortals") {
      return (
        <Button
          onClick={() => {
            navigate("/dedicated/passenger/footer/icons/servicePortals/add");
          }}
          icon={<Icon icon="lucide:plus" />}
        >
          Add Service Portal
        </Button>
      );
    } else if (subActiveTab === "socialMedia") {
      return (
        <Button
          onClick={() => {
            navigate("/dedicated/passenger/footer/icons/socialMedia/add");
          }}
          icon={<Icon icon="lucide:plus" />}
        >
          Add Social Media
        </Button>
      );
    }
  };

  return (
    // <ContentWrapper
    //   title="Footer"
    //   bodyStyle={{ height: "calc(100vh - 100px)", overflowY: "auto" }}
    //   actionItems={handleFooterAction(query.get('subActiveTab'))}
    // >
    <>
      <Tabs
        activeKey={subActiveTab || "aboutAndLegal"}
        items={items}
        onChange={(key) => navigate(`${window.location.pathname}?activeTab=passengerFooter&subActiveTab=${key}`)}
      />
    </>
  );
};

export default FooterPassenger;
